function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".pythonFill-1{fill:url(#linear-gradient);}.pythonFill-2{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 55.29,
  y1: 34.67,
  x2: 109.89,
  y2: -20.11,
  gradientTransform: "matrix(1, 0, 0, -1, -44.94, 44.53)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#387eb8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#366994"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 88.87,
  y1: -0.2,
  x2: 147.51,
  y2: -56.38,
  gradientTransform: "matrix(1, 0, 0, -1, -44.94, 44.53)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffe052"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffc331"
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "python");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "layer1"
}, /*#__PURE__*/React.createElement("g", {
  id: "g1894"
}, /*#__PURE__*/React.createElement("path", {
  id: "path8615",
  className: "pythonFill-1",
  d: "M54.81,0c-28,0-26.28,12.16-26.28,12.16l0,12.59H55.31v3.78H17.94S0,26.5,0,54.78,15.66,82.06,15.66,82.06H25V68.94s-.5-15.66,15.41-15.66H66.94s14.9.24,14.9-14.4V14.66S84.11,0,54.81,0ZM40.06,8.47a4.81,4.81,0,1,1-4.81,4.81A4.81,4.81,0,0,1,40.06,8.47Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path8620",
  className: "pythonFill-2",
  d: "M55.61,109.85c28,0,26.28-12.16,26.28-12.16l0-12.59H55.11V81.31H92.48s17.94,2,17.94-26.25S94.76,27.78,94.76,27.78H85.42V40.91S85.92,56.56,70,56.56H43.48S28.58,56.32,28.58,71V95.19S26.31,109.85,55.61,109.85Zm14.75-8.47a4.82,4.82,0,1,1,4.81-4.82A4.81,4.81,0,0,1,70.36,101.38Z"
})));

var SvgPython = function SvgPython(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2169",
    viewBox: "0 0 110.42 109.85",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPython, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/python.e2f8c511.svg";
export { ForwardRef as ReactComponent };